import { render, staticRenderFns } from "./PropertyVideoCard.vue?vue&type=template&id=4d2bf72f&scoped=true"
import script from "./PropertyVideoCard.vue?vue&type=script&lang=js"
export * from "./PropertyVideoCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyVideoCard.vue?vue&type=style&index=0&id=4d2bf72f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bf72f",
  null
  
)

export default component.exports